import gql from 'graphql-tag';

export default gql`
  query confirmEmail($email: EmailAddress!) {
    confirmEmail(email: $email)
  }
`;
